import React from 'react';

import { useAccountActions } from './AccountContext';
import PageSectionTitleWithActions from '../../Shared/UI/PageSectionTitleWithActions/components/PageSectionTitleWithActions';
import Button from '../../Shared/UI/Button/components/Button';

const CloseAccountPageSectionTitle = () => {
  const { openAccountCloseModal } = useAccountActions();

  return (
    <PageSectionTitleWithActions
      text="Close Account"
      actions={
        <Button
          variant="destructive"
          onClick={() => {
            openAccountCloseModal();
          }}
        >
          Close Permanently
        </Button>
      }
    />
  );
};

export default CloseAccountPageSectionTitle;